import React from 'react';

import { Grid } from '@material-ui/core';

import { AutoComplete } from '../../../components/AutoComplete/AutoComplete';
import Button from '../../../components/Button';
import DatePicker from '../../../components/DatePicker';
import { IFilterOptions } from './Ledger';
import { getFilterOptionsFromSet } from './Utils/getFilterOptionsFromSet';

interface ITransactionsFilters {
  clearFilters: any;
  filterOptions: IFilterOptions;
  selectedDateEndFilterOption: any;
  selectedDateStartFilterOption: any;
  selectedEventNameFilterOption: string;
  selectedPayeerFilterOption: string;
  selectedTypeFilterOption: string;
  setSelectedDateEndFilterOption: any;
  setSelectedDateStartFilterOption: any;
  setSelectedEventNameFilterOption: any;
  setSelectedPayeerFilterOption: any;
  setSelectedTypeFilterOption: any;
}

const getFilterOptionValue = (option: string) => (option ? { label: option, value: option } : null);

export const TransactionsFilters = (props: ITransactionsFilters) => {
  const {
    clearFilters,
    filterOptions,
    selectedDateEndFilterOption,
    selectedDateStartFilterOption,
    selectedEventNameFilterOption,
    selectedPayeerFilterOption,
    selectedTypeFilterOption,
    setSelectedDateEndFilterOption,
    setSelectedDateStartFilterOption,
    setSelectedEventNameFilterOption,
    setSelectedPayeerFilterOption,
    setSelectedTypeFilterOption
  } = props;

  const onSetSelectedOption = (setFunction: any) => (option: any) =>
    setFunction(option ? option.value : '');

  const onSetDateOption = (setFunction: any) => (date: any) => setFunction(date);

  return (
    <div className="filters-section">
      <div className="filters-header">
        <h3>FILTER TRANSACTIONS</h3>

        <Button
          className="clear-filters"
          style={{ width: 'initial' }}
          color="primary"
          type="button"
          onClick={clearFilters}
        >
          CLEAR FILTERS
        </Button>
      </div>

      <Grid className="grid" container={true} spacing={8}>
        <Grid className="grid-item" item={true} xs={12} md={3}>
          <p className="filter-label">ITEM OR EVENT</p>
          <AutoComplete
            value={getFilterOptionValue(selectedEventNameFilterOption)}
            placeholder="SEARCH OR SELECT"
            onChange={onSetSelectedOption(setSelectedEventNameFilterOption)}
            options={getFilterOptionsFromSet('eventNames', filterOptions)}
            isClearable={true}
          />
        </Grid>
        <Grid className="grid-item" item={true} xs={12} md={3}>
          <p className="filter-label">PLAYER SEARCH</p>
          <AutoComplete
            value={getFilterOptionValue(selectedPayeerFilterOption)}
            placeholder="SEARCH OR SELECT"
            onChange={onSetSelectedOption(setSelectedPayeerFilterOption)}
            options={getFilterOptionsFromSet('payeers', filterOptions)}
            isClearable={true}
          />
        </Grid>
        <Grid className="grid-item" item={true} xs={12} md={3}>
          <p className="filter-label">CHOOSE A DATE RANGE</p>
          <div className="datepickers-wrapper">
            <DatePicker
              value={selectedDateStartFilterOption ? selectedDateStartFilterOption : undefined}
              id="season-start"
              label=""
              placeholder="01/01/2019"
              fullWidth={true}
              onChange={onSetDateOption(setSelectedDateStartFilterOption)}
              noKeyboard={true}
            />
            <h4 className="big-text">TO</h4>
            <DatePicker
              value={selectedDateEndFilterOption ? selectedDateEndFilterOption : undefined}
              id="season-end"
              label=""
              placeholder="12/31/2020"
              fullWidth={true}
              onChange={onSetDateOption(setSelectedDateEndFilterOption)}
              noKeyboard={true}
            />
          </div>
        </Grid>
        <Grid className="grid-item" item={true} xs={12} md={3}>
          <p className="filter-label">TYPE</p>
          <AutoComplete
            value={getFilterOptionValue(selectedTypeFilterOption)}
            placeholder="SEARCH OR SELECT"
            onChange={onSetSelectedOption(setSelectedTypeFilterOption)}
            options={getFilterOptionsFromSet('types', filterOptions)}
            isClearable={true}
          />
        </Grid>
      </Grid>
    </div>
  );
};
